import { BUCKETS } from "@/constants";
import { supabase } from "@/services/supabase/createClient";

export const removeFileFromStorage = async (promptbookId: string, fileIds: string[]) => {
  const filePaths = fileIds.map((fileId) => `${promptbookId}/files/${fileId}`);

  if (!filePaths.length) {
    return null;
  }

  const { data, error } = await supabase.storage.from(BUCKETS.promptbooks).remove(filePaths);

  if (error) {
    throw error;
  }

  return data;
};
